module.exports = __webpack_public_path__ + "static/media/rounded-plus-grey-icon.0f4b2cf0.svg";